export interface IHeader {
    name: string;
    data: string;
}

export class HttpResource {

    public baseUrl: string = '';
    public headers: Array<IHeader> = [];
    public contentJson: IHeader = {name: 'Content-Type', data: 'application/json' };

    /**
     * GET requests
     * @param  {string} url
     * @param  {Array<IHeader>} headers
     */
    public get(url: string, headers: Array<IHeader> = []) {
        return this.request(url, 'GET', headers);
    }

    /**
     * PUT requests
     * @param  {string} url
     * @param  {Array<IHeader>} headers
     * @param  {any} [data]
     */
    public put(url: string, headers: Array<IHeader> = [], data?: any) {
        headers.push(this.contentJson);
        return this.request(url, 'PUT', headers, JSON.stringify(data));
    }

    /**
     * POST requests
     * @param  {string} url
     * @param  {Array<IHeader>} headers
     * @param  {any} [data]
     */
    public post(url: string, headers: Array<IHeader> = [], data?: any) {
        headers.push(this.contentJson);
        return this.request(url, 'POST', headers, JSON.stringify(data));
    }

    /**
     * DELETE requests
     * @param  {string} url
     * @param  {Array<IHeader>} headers
     */
    public delete(url: string, headers: Array<IHeader> = []) {
        return this.request(url, 'DELETE', headers);
    }

    /**
     * Sets the base url which is used on every request
     * @param  {string} url
     */
    public setBaseUrl(url: string) {
        this.baseUrl = url;
    }

    /**
     * Adds a header to a list which are added to every request
     * @param  {IHeader} header
     * @returns {Function} to remove header
     */
    public addHeader(header: IHeader): () => void {
        this.headers.push(header);
        return () => {
            this.headers = this.headers.filter((item) => {
                return (item !== header);
            });
        };
    }

    /**
     * xhr requests
     * @param  {string} url
     * @param  {string} method
     * @param  {Array<IHeader>} headers
     * @param  {any} [data]
     * @returns Promise
     */
    private request(url: string, method: string, headers: Array<IHeader>, data?: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            const _url = this.baseUrl + url;
            const _headers = [...this.headers, ...headers];
            xhr.open(method, _url);
            _headers.forEach((header) => {
                xhr.setRequestHeader(header.name, header.data);
            });
            xhr.onload = () => {
                if (xhr.status >= 200 && xhr.status < 400) {
                    try {
                        resolve(JSON.parse(xhr.response));
                    } catch (e) {
                        resolve(xhr.response);
                    }
                } else {
                    reject({response: xhr.statusText, status: xhr.status});
                }
            };
            xhr.onerror = () => reject({response: xhr.statusText, status: xhr.status});
            if (method === 'POST' || method === 'PUT') {
                xhr.send(data);
            } else {
                xhr.send();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/resources/http.resource/http.resource.ts